import React, { useEffect, useState } from 'react'
import { Calendar } from 'primereact/calendar'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment'

import JournalEntriesTable from './JournalEntriesTable'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6'
import { resetEntries } from '../../store/slices/TransactionsSlice'
import { useDispatch } from 'react-redux'

const CreateJournalEntries = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const [date, setDate] = useState(new Date())
  const transactionData = location.state?.transactionData
  const activeTab =
    location.state?.activeTab ||
    (transactionData?.manual_entry === false ? 'his' : 'journal')
  const [transactionId, setTransactionId] = useState(transactionData?.id || null)
  const [transactionStatus, setTransactionStatus] = useState(
    transactionData?.status || null
  )
  const [debitTotal, setDebitTotal] = useState(0)
  const [creditTotal, setCreditTotal] = useState(0)
  const currentDateTime = new Date()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (transactionData) {
      setTransactionId(transactionData?.id)
      setTransactionStatus(transactionData?.status || null)
      setDate(moment(transactionData.date).toDate())
    }
  }, [transactionData])

  return (
    <div className='rounded-md min-h-[85vh] overflow-hidden bg-gray-100 p-2 px-4 w-full'>
      <div className='flex gap-5 items-center '>
        <div className='flex justify-center items-center gap-5'>
          <div
            onClick={() => {
              navigate(-1)
              dispatch(resetEntries())
            }}
            className='w-[30px] h-[30px]  lg:h-[35px] lg:w-[35px] text-primary flex justify-center items-center rounded-full bg-white cursor-pointer '
          >
            {i18n.language === 'en' ? (
              <FaArrowLeft size={18} />
            ) : (
              <FaArrowRight size={18} />
            )}
          </div>
          <h2 className='text-3xl min-w-[300px] font-bold text-gray-800'>
            {transactionData
              ? (transactionData.entry_type === "OPENING" ? t("Edit Opening Balance") : t('edit_journal_entries'))
              : t('create_journal_entries')}
          </h2>
        </div>
        <div className='grid grid-cols-2 gap-4 flex-grow'>
          <div className='flex flex-col gap-1'>
            <Calendar
              id='date'
              value={date}
              onChange={(e) => setDate(e.value)}
              // showTime
              // hourFormat="24"
              dateFormat="dd-mm-yy"
              maxDate={currentDateTime}
              className='w-full !p-0 rounded-md hover:border-primary !outline-none !shadow-none'
              pt={{
                root: { className: '!h-[30px]' },
                input: { className: '!p-1 !h-[30px]' }
              }}
            />
          </div>
        </div>
        <div className='flex gap-4 justify-end'>
          <div>
            <span className='font-bold text-[18px]'>{t('Total Debit')}: </span>
            <span className='text-[18px]'>{debitTotal.toFixed(2)}</span>
          </div>
          <div>
            <span className='font-bold text-[18px]'>{t('Total Credit')}: </span>
            <span className='text-[18px]'>{creditTotal.toFixed(2)}</span>
          </div>
        </div>
      </div>
      <JournalEntriesTable
        debitTotal={debitTotal}
        setDebitTotal={setDebitTotal}
        creditTotal={creditTotal}
        setCreditTotal={setCreditTotal}
        date={date}
        transactionId={transactionId}
        transactionStatus={transactionStatus}
        transactionDescription={transactionData?.description}
        returnActiveTab={activeTab}
      />
    </div>
  )
}

export default CreateJournalEntries
